













































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import DraggableList from '@/components/DraggableList.vue';
import { Option } from '@/interfaces';

@Component({
  components: {
    DraggableList
  }
})
export default class NewCustomField extends Mixins(CommonMixin) {
  // Props
  @Prop(Boolean) public readonly isReadOnly!: boolean;
  @Prop(Object) public readonly rec!: any;
  @Prop({ type: Boolean, default: false })
  public readonly siteSpecific!: boolean;

  public items: Option[] = [];
  public version = 1;

  // Custom filter autocomplete to ignore spaces (trim)
  public customFilter(item, queryText, itemText) {
    return (
      itemText
        .toLocaleLowerCase()
        .indexOf(queryText.trim().toLocaleLowerCase()) > -1
    );
  }

  public initializeItems(rec) {
    const items = this.buildOptionList(rec.values_nl);
    if (items) {
      this.items = items;
    }
  }

  public updateVersion() {
    this.version += 1;
  }

  public change(rec) {
    if (rec.default_index === undefined) {
      rec.default_index = -1;
      rec.default = null;
    } else if (rec.default_index === -1) {
      rec.default = null;
    } else {
      rec.default = this.items[rec.default_index].text;
    }
  }

  public updateItems(rec) {
    const items = this.buildOptionList(rec.values_nl);
    if (items) {
      this.items = items;
      if (rec.default_index !== -1) {
        if (rec.default_index < items.length) {
          rec.default = this.items[rec.default_index].text;
        } else {
          rec.default = null;
        }
      }
    }
    this.updateVersion();
  }

  public typeChanged() {
    // Reset items
    if (this.rec.linedatatype_id === 3) {
      this.rec.values_nl = [];
      this.rec.values_fr = [];
    } else {
      this.rec.values_nl = null;
      this.rec.values_fr = null;
    }
    this.rec.default_index = -1;
    this.rec.default = null;
    this.items = [];
  }

  @Watch('rec') public recChanged(value: string, oldValue: string) {
    if (this.rec.values_nl && this.rec.values_nl !== []) {
      this.initializeItems(this.rec);
    }
  }
}
